import { Menu, MenuProps } from 'antd';
import React from 'react';

import styles from './styles/Shortcuts.less';

const Shortcuts = (props) => {
  const { shortcuts, selected, onChange, live, showCustom } = props;

  const onMenuSelect = ({ key }) => {
    const selectedShortcut = shortcuts.find(([shortcut]) => shortcut === key);
    if (selectedShortcut) {
      const [, selectedInterval] = selectedShortcut;
      onChange(selectedInterval, key);
    }
  };

  const items: MenuProps['items'] = [
    ...(live ? [{ key: 'live', label: 'Live' }] : []),
    ...shortcuts.map(([shortcut]) => ({ key: shortcut, label: shortcut })),
  ];
  if (showCustom) {
    items.push({ key: 'custom', label: 'Custom' });
  }

  return (
    <Menu
      selectedKeys={[selected]}
      className={styles.shortcuts}
      onClick={onMenuSelect}
      items={items}
    />
  );
};

Shortcuts.defaultProps = {
  selected: 'custom',
  live: false,
};

export default Shortcuts;
